const typeLabels = {
  legislation: "Normativa",
  doctrine: "Doctrina",
  jurisprudence: "Jurisprudencia",
  case_record: "Expediente",
  attachment: "Archivo adjunto",
  library: "Fuente del cuaderno",
  official_web: "Fuente oficial externa",
};

export function normalizeCitation(citation = {}) {
  const source = citation.source || citation.metadata?.source || (
    citation.sourceUrl || citation.tribunaleaUrl
      ? {
          url: citation.sourceUrl || null,
          tribunaleaUrl: citation.tribunaleaUrl || null,
        }
      : {}
  );
  return {
    ...citation,
    type: citation.type || citation.citationType || "source",
    label:
      citation.label ||
      citation.locator ||
      source.title ||
      "Fuente registrada",
    source,
  };
}

export function citationTypeLabel(type) {
  return typeLabels[type] || "Fuente";
}

export function safeSourceUrl(value) {
  if (!value) return null;
  try {
    const url = new URL(value);
    return ["http:", "https:"].includes(url.protocol) ? url.href : null;
  } catch {
    return null;
  }
}

export function latestCitationReferences(messages = []) {
  const sourceMessage = [...(messages || [])].slice(-6).reverse().find((message) => (
    message?.role === "assistant" && message.citations?.length
  ));
  return normalizeCitationReferences(sourceMessage?.citations || []).slice(0, 50);
}
import { normalizeCitationReferences } from "@tribunalea/shared";
